<template>
  <div>
    <Layout/>
    <h4>Medios de Comunicación</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioCom" class="form-label">IdMedioCom</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoMedioCom.idMedioCom" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoMedioCom.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarMedioCom" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedioCom" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedioCom" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdMedioEmp</th>
          <th scope="col">IdMedioCom</th>
          <th scope="col">IdEmpresa</th>
          <th scope="col">Descripción</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">Medio de Comunicación</th>
          <th scope="col">EmpresaNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medioemp in datosPaginados" :key="medioemp.idMedioEmp">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(medioemp.idMedioEmp)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(medioemp.idMedioEmp)" title="Editar">edit_square</i></td>
          <td>{{medioemp.idMedioEmp}}</td>
          <td>{{medioemp.idMedioCom}}</td>
          <td>{{medioemp.idEmpresa}}</td>
          <td>{{medioemp.descripcion}}</td>
          <td>{{getFormattedDate(medioemp.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{medioemp.estado}}</td>
          <td>{{medioemp.medioComNombre}}</td>
          <td>{{medioemp.empresaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMedioCom(medioemp.idMedioEmp)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioEmp" class="form-label">IdMedioEmp</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioEmp" name="idMedioEmp" v-model="datoMedioEmp.idMedioEmp" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioCom" class="form-label">IdMedioCom</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoMedioEmp.idMedioCom" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoMedioEmp.idEmpresa"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label"> Empresa</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="empresa" name="empresa" v-model="datoMedioEmp.empresa" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEmpresaLOV"
                      title="Buscar Empresas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoMedioEmp.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoMedioEmp.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedioEmp" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedioEmp" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: MedioEmp -->
    <MedioEmpLOVdet @DatosMedioEmp="GetDataMedioEmpLOVdet($event)"/>
<!-- Lista de Valores: Empresa -->
    <EmpresaLOVdet @DatosEmpresa="GetDataEmpresaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import MedioEmpLOVdet from '../../components/lovs/MedioEmpLOV.vue'
import EmpresaLOVdet from '../../components/lovs/EmpresaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, MedioEmpLOVdet
, EmpresaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      mediocoms : [],
      datoMedioCom : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMedioCom: '',
// Variables master
// Variables details
      medioemps : [],
      datoMedioEmp : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMedioCom = this.$route.params.p_idmediocom
    this.abrirEditar(this.p_idMedioCom)
    this.getMedioEmps()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoMedioCom.idMedioCom === ''){
        swal("Error!", "El elemento idMedioCom no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioCom.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioCom.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedioCom(){
      if(this.validarForm() === 1){
        try {
          await api.post('/mediocoms', this.datoMedioCom)
          swal("Correcto!", "MedioCom creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedioCom(){
      if(this.validarForm() === 1){
        try {
          await api.post('/mediocoms', this.datoMedioCom)
          swal("Correcto!", "MedioCom creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMedioCom={}
      this.titulo   = 'Crear Medios de Comunicación'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMedioCom){
      this.modalWindow = true
      if(idMedioCom != null){    
           api.get('/vwmediocoms/'+idMedioCom).then(resp=>{
          this.datoMedioCom = resp.data;
           });
      }
      this.titulo   = 'Editar Medios de Comunicación'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMedioCom(){
      this.$router.push('/MedioCom')
    },
// Procedimientos master
// Procedimientos detalle
    async getMedioEmps() {
      const resp = await api.get('/medioemps')
      this.medioemps = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.medioemps.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmedioemps/nombre/'+this.nombreBusqueda).then(response=>{
          this.medioemps=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.medioemps.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedioemps').then(response=>{
      this.medioemps=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medioemps.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoMedioEmp.idMedioCom === ''){
        swal("Error!", "El elemento idMedioCom no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioEmp.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedioEmp.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedioEmp(){
      if(this.validarForm() === 1){
        try {
          this.datoMedioEmp.idMedioCom = this.datoMedioCom.idMedioCom;
          await api.post('/medioemps', this.datoMedioEmp)
          this.getMedioEmps();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "MedioEmp creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedioEmp(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medioemps', this.datoMedioEmp)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "MedioEmp creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedioEmp={}
      this.titulo   = 'Crear Medios de Comunicación'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idMedioEmp){
      this.modalWindow = true
      if(idMedioEmp != null){    
           api.get('/vwmedioemps/'+idMedioEmp).then(resp=>{
          this.datoMedioEmp = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Medios de Comunicación'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idMedioEmp){
      this.modalWindow = true
      if(idMedioEmp != null){
        this.$router.push('/medioempmd/'+idMedioEmp)
      }
    },
    async deleteMedioEmp (idMedioEmp) {
      try{
        await api.delete('/medioemps/'+idMedioEmp)
          this.getMedioEmps()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataMedioEmpLOVdet(data) {
      this.datoMedioEmp.idMedioEmp = data.idMedioEmp;
      this.datoMedioEmp.medioEmp = data.nombre;
    },
//    Lista de Valores
    GetDataEmpresaLOVdet(data) {
      this.datoMedioEmp.idEmpresa = data.idEmpresa;
      this.datoMedioEmp.empresa = data.nombre;
    },
// Listas de valores details
  },
}
</script>
